import {
  IconBriefcase,
  IconChartCovariate,
  IconFileWord,
  IconGlobe,
  IconMail,
  IconMapPin,
  IconRss,
  IconUsers,
  IconWorld,
} from "@tabler/icons-react";

export enum AdminSidebarTabs {
  JOBS = "jobs",
  JOB_COUNT = "job-count",
  COUNTRY_REPORT = "country-report",
  REGION_REPORT = "region-report",
  CITY_REPORT = "city-report",
  WORD_EXPORT_REPORT = "word-export-report",
  RSS_CONFIG = "rss-config",
  EMAIL_ALERT_REPORT = "email-alert-report",
  USER_REPORT = "user-report",
}

export const adminSidebarTabsList: {
  name: AdminSidebarTabs;
  icon: React.FC<any>;
  tooltip: string;
}[] = [
  {
    name: AdminSidebarTabs.JOBS,
    icon: IconBriefcase,
    tooltip: "Jobs report",
  },
  {
    name: AdminSidebarTabs.JOB_COUNT,
    icon: IconChartCovariate,
    tooltip: "Job count report",
  },
  {
    name: AdminSidebarTabs.COUNTRY_REPORT,
    icon: IconWorld,
    tooltip: "Country report",
  },
  {
    name: AdminSidebarTabs.REGION_REPORT,
    icon: IconGlobe,
    tooltip: "Region report",
  },
  {
    name: AdminSidebarTabs.CITY_REPORT,
    icon: IconMapPin,
    tooltip: "City report",
  },
  {
    name: AdminSidebarTabs.WORD_EXPORT_REPORT,
    icon: IconFileWord,
    tooltip: "Word export report",
  },
  {
    name: AdminSidebarTabs.RSS_CONFIG,
    icon: IconRss,
    tooltip: "RSS configuration",
  },
  {
    name: AdminSidebarTabs.EMAIL_ALERT_REPORT,
    icon: IconMail,
    tooltip: "Email Alert report",
  },
  {
    name: AdminSidebarTabs.USER_REPORT,
    icon: IconUsers,
    tooltip: "Registered users report",
  },
];

export function isAdminSidebarTab(
  value: string | undefined,
): value is AdminSidebarTabs {
  return Object.values(AdminSidebarTabs).includes(value as AdminSidebarTabs);
}
